// extracted by mini-css-extract-plugin
export default {"header":"home_header__Qu+Wv","detailContainer":"home_detailContainer__vyh+v","details":"home_details__We6bh","mainText":"home_mainText__vGlAL"};